/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Button, Typography2 } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import FactCheckIcon from 'bundles/academic-integrity/components/viva-exam/integrity-check-chat/assets/FactCheckIcon';

import _t from 'i18n!nls/academic-integrity';

const styles = {
  footer: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: var(--cds-spacing-200) var(--cds-spacing-400) var(--cds-spacing-200) var(--cds-spacing-400);
  `,
  questionsAnswered: css`
    display: flex;
    margin-right: var(--cds-spacing-300);
    margin-left: var(--cds-spacing-100);
  `,
};

type IntegrityCheckChatFooterProps = {
  totalQuestions: number;
  onDismiss: () => void;
  isExamComplete: boolean;
  isReadOnly: boolean;
  questionsAnsweredCount: number;
  assignmentId?: string;
  courseId?: string;
  vivaExamSessionId?: string | null;
};

const IntegrityCheckChatFooter = ({
  totalQuestions,
  onDismiss,
  isExamComplete,
  isReadOnly,
  questionsAnsweredCount,
  assignmentId,
  courseId,
  vivaExamSessionId,
}: IntegrityCheckChatFooterProps) => {
  const track = useTracker();

  const handleDone = () => {
    track('click_button', {
      button: {
        name: 'integrity_check_done',
      },
      assignment: {
        id: assignmentId ?? '',
      },
      product: {
        type: 'course',
        id: courseId ?? '',
      },
      vivaExam: {
        id: vivaExamSessionId ?? '',
      },
    });
    onDismiss();
  };
  return (
    <div css={styles.footer}>
      <FactCheckIcon />
      <div css={styles.questionsAnswered}>
        <Typography2 variant="bodyPrimary" component="div">
          <FormattedMessage
            message={_t(
              '{questionsAnsweredCount, number} out of {totalQuestions, number} {totalQuestions, plural, =1 {question} other {questions}} answered'
            )}
            questionsAnsweredCount={questionsAnsweredCount}
            totalQuestions={totalQuestions}
          />
        </Typography2>
      </div>

      {isReadOnly ? (
        <Button onClick={onDismiss}>{_t('Go Back')}</Button>
      ) : (
        <Button disabled={!isExamComplete} onClick={handleDone}>
          {_t('Done')}
        </Button>
      )}
    </div>
  );
};

export default IntegrityCheckChatFooter;
